import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  CustomPanel,
  Loading,
  PageHeader,
  CustomModal,
  CustomDataTableHeader,
  BadgeStatusEntrega,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import useCargasPendentesParaPicking from './CargasPendentesParaPickingState'

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CargasPendentesParaPicking))

function CargasPendentesParaPicking({ history, selectedTp, dispatch }) {
  const { state, localDispatch } = useCargasPendentesParaPicking()
  const [globalFilterModal, setGlobalFilterModal] = useState('')

  useEffect(() => {
    ;(selectedTp !== null || selectedTp !== undefined) && localDispatch.fetchEntregas(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    state.errorMessage &&
      dispatch(showMessageBox(null, state.errorMessage)) &&
      localDispatch.resetMessage()
  }, [state.errorMessage])

  const headerModal = (
    <CustomDataTableHeader onChange={setGlobalFilterModal}>
      <div />
    </CustomDataTableHeader>
  )

  return (
    <>
      <PageHeader>4.6 - Cargas Pendentes Para Picking</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          {state.isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            <DataTable
              value={state.cargas}
              rows={15}
              paginator
              emptyMessage="Nenhuma entrega encontrada"
              selectionMode="single"
              onSelectionChange={e => localDispatch.onRowClick(e.value, selectedTp)}
            >
              <Column
                field="data_importacao"
                header="Data Importação"
                style={tableCellCentered(150)}
              />
              <Column
                field="data_programacao"
                header="Data Programação"
                style={tableCellCentered(160)}
              />
              <Column field="empresa" header="Empresa" />
              <Column field="ciclo_entrega" header="Ciclo de Entrega - Origem" />
              <Column field="step" header="Trecho" style={tableCellCentered()} />
              <Column field="qte_notas" header="Qte. Notas" style={tableCellCentered()} />
              <Column field="qte_skus" header="Qte. Caixas" style={tableCellCentered(130)} />
              <Column field="peso" header="Peso" style={tableCellCentered()} />
            </DataTable>
          )}
        </CustomPanel>
      </div>

      <CustomModal
        header="Entregas"
        isVisible={state.modal.show}
        onClose={localDispatch.onModalClose}
        width="70vw"
        style={{ maxHeight: '110vh' }}
        contentStyle={{ maxHeight: '100vh', overflow: 'auto' }}
      >
        {state.modal.isLoading ? (
          <div className="text-center">
            <Loading />
          </div>
        ) : (
          <DataTable
            value={state.modal.deliveries}
            rows={10}
            paginator
            emptyMessage="Nenhuma entrega encontrada"
            header={headerModal}
            globalFilter={globalFilterModal}
          >
            <Column field="nota_fiscal" header="Identificador" style={tableCellCentered(120)} />
            <Column field="empresa" header="Empresa" />
            <Column
              field="status"
              header="Status"
              style={tableCellCentered(150)}
              body={row => <BadgeStatusEntrega status={row.status} />}
            />
            <Column field="qte_caixas" header="Qte. Sku" style={tableCellCentered(120)} />
            <Column
              field="peso_nota"
              header="Peso"
              style={tableCellCentered(100)}
              body={row => row.peso_nota.toFixed(2)}
            />
            <Column
              field="valor_nota"
              header="Valor"
              style={tableCellCentered(120)}
              body={row =>
                row.valor_nota ? `R$ ${row.valor_nota.toFixed(2).replace('.', ',')}` : '-'
              }
            />
          </DataTable>
        )}
      </CustomModal>
    </>
  )
}
